import { Component, OnInit } from "@angular/core";
import { SvgIcon } from "@merri/common";

@Component({
    selector: "app-icon-tester",
    templateUrl: "./icon-tester.component.html",
    styleUrls: ["./icon-tester.component.scss"],
    standalone: false
})
export class IconTesterComponent implements OnInit {
  icons: SvgIcon;
  constructor() {}

  ngOnInit(): void {
    this.icons = Object.keys(SvgIcon).map(k => SvgIcon[k]);
  }
}
